
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcPoiObject as ObcPoiObjectElement} from '@oicl/openbridge-webcomponents/dist/ar/building-blocks/poi-object/poi-object.js';
 
 
 

 
 export const ObcPoiObject = createComponent({
   react: React,
   tagName: 'obc-poi-object',
   elementClass: ObcPoiObjectElement,
   events: {
     
   }
  });
 
 